import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import IconButton from '@material-ui/core/IconButton'

import { TableTitle } from '../../common'

import * as Strings from './strings'
import * as configActions from '../../actions/Config'

class LaundryTable extends Component {
  render() {
    const { classes, data } = this.props
    const laundryRules = data.laundrySystem.laundryRule
    let maxBookings =
      laundryRules.maxBookings.toString() === '0'
        ? Strings.default.NO_LIMIT
        : laundryRules.maxBookings +
          ' ' +
          Strings.default.LAUNDRY_TIMES_AT_A_TIME

    if (laundryRules.maxBookings.toString() === '1') {
      maxBookings =
        laundryRules.maxBookings + ' ' + Strings.default.LAUNDRY_TIME_AT_A_TIME
    }

    let bookingRange =
      laundryRules.bookingRange.toString() === '0'
        ? Strings.default.NO_LIMIT
        : laundryRules.bookingRange + ' ' + Strings.default.WEEKS

    if (laundryRules.bookingRange.toString() === '1') {
      bookingRange = laundryRules.bookingRange + ' ' + Strings.default.WEEK
    }

    const parsedLaundryRules = [
      {
        name: Strings.default.LAUDRY_TYPE,
        value: Strings.default.LAUNDRIES[laundryRules.laundryType],
        onEdit: () => this.props.showEditLaundryTypeModal(),
        key: laundryRules.id * 1
      },
      {
        name: Strings.default.BOOKING_RANGE,
        value: bookingRange,
        onEdit: () => this.props.showEditBookingRangeModal(),
        key: laundryRules.id * 2
      },
      {
        name: Strings.default.MAX_BOOKINGS,
        value: maxBookings,
        onEdit: () => this.props.showEditMaxBookingsModal(),
        key: laundryRules.id * 3
      }
    ]

    return (
      <div>
        <Paper className={classes.root}>
          <TableTitle
            classes={classes}
            header={Strings.default.MANAGE_GENERAL_SETTINGS}
            addIcon={false}
            withBottomBorder
          />
          <Table className={classes.table} aria-labelledby={'tableTitle'}>
            <TableBody>
              {parsedLaundryRules.map(laundryRule => {
                return (
                  <TableRow key={laundryRule.key} className={classes.row}>
                    <TableCell>{laundryRule.name}</TableCell>
                    <TableCell>{laundryRule.value}</TableCell>
                    <TableCell numeric>
                      <IconButton
                        aria-label={'Ändra'}
                        onClick={() => laundryRule.onEdit()}
                      >
                        <FontAwesomeIcon
                          icon={faEdit}
                          color={'#3B424D'}
                          style={{ fontSize: 16 }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </Paper>
      </div>
    )
  }
}

const Styles = {
  root: {
    width: '100%',
    overflowX: 'auto'
  },
  table: {
    minWidth: 700
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#fafafa'
    }
  },
  spacer: {
    flex: '1 1 100%'
  },
  actions: {
    color: 'green'
  },
  title: {
    flex: '0 0 auto'
  }
}

LaundryTable.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps({ data, user }) {
  return { data, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions }, dispatch)
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(LaundryTable)



// WEBPACK FOOTER //
// ./src/components/containers/LaundryRulesTable/index.js